import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Gauge, X } from 'lucide-react';
import { telematicsAPI } from '../services/api';
import { useAuth } from '../contexts/AuthContext';

const TelematicsCaptureBanner = () => {
  const location = useLocation();
  const envPrefix = location.pathname.startsWith('/test') ? '/test' : '';
  const { isSupervisor, isAdmin } = useAuth();
  const [status, setStatus] = useState(null);
  const [dismissed, setDismissed] = useState(false);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchStatus = async () => {
      if (!isSupervisor && !isAdmin) {
        setLoading(false);
        return;
      }

      try {
        const response = await telematicsAPI.getBannerStatus();
        setStatus(response.data);
      } catch (error) {
        console.error('Failed to fetch telematics status:', error);
      } finally {
        setLoading(false);
      }
    };

    fetchStatus();
  }, [isSupervisor, isAdmin]);

  if (loading || dismissed || !status?.needs_upload || (!isSupervisor && !isAdmin)) {
    return null;
  }

  return (
    <div className="bg-rose-600 text-white px-4 py-2" data-testid="telematics-capture-banner">
      <div className="max-w-7xl mx-auto flex items-center justify-between">
        <div className="flex items-center gap-3">
          <Gauge className="w-5 h-5" />
          <span className="font-medium">Daily Telematics Reports Required</span>
          <span className="text-rose-200">
            {status.message}
          </span>
          <Link 
            to={`${envPrefix}/telematics`}
            className="bg-white text-rose-700 px-3 py-1 rounded-md text-sm font-semibold hover:bg-rose-100 transition-colors ml-2"
          >
            Upload Reports
          </Link>
        </div>
        <button 
          onClick={() => setDismissed(true)}
          className="hover:bg-white/20 rounded p-1"
          aria-label="Dismiss banner"
        >
          <X className="w-4 h-4" />
        </button>
      </div>
    </div>
  );
};

export default TelematicsCaptureBanner;
